import TextLato from '@photosi/rn-components/text/text-lato/TextLato';
import { observer } from 'mobx-react-lite';
import { ScrollView, View } from 'react-native';
import { useStore } from '../../../../contexts/StoreContext';
import { TestIDs } from 'src/constants/testIDs.constants';
import { style } from './ModalUploadError.style';
import { DynamicModalProps } from '../DynamicModal.types';
import BaseModal from '../../base-modal/BaseModal';
import { Illustration } from '@photosi/rn-components/illustration/Illustration';
import { ILLUSTRATION_NAMES } from '@photosi/rn-components/illustration/illustration.helper';

export const ModalUploadError = observer(
  ({ type, dynamicModalVisible, dynamicModalLayer: { id, onPressDiscardChanges } }: DynamicModalProps) => {
    const {
      i18n,
      dynamicModal: { closeModal, activeModal },
      data: { fileListError },
    } = useStore();

    const onConfirm = () => {
      onPressDiscardChanges && onPressDiscardChanges();
      closeModal();
    };

    const { titleKey, descriptionKey, errorItems, ctaKey } = activeModal?.uploadErrorData ?? {
      titleKey: 'upload:upload-error-title',
      descriptionKey: 'upload:upload-error-description-list',
      errorItems: fileListError || [],
      ctaKey: 'modal-upload-error:cta',
    };

    return (
      <BaseModal
        testID={TestIDs.UPLOAD_ERROR}
        modalWidth={386}
        modalIcon={
          <View style={{ width: 54, height: 54 }}>
            <Illustration name={ILLUSTRATION_NAMES.ImportFailed} />
          </View>
        }
        title={i18n.t(titleKey)}
        body={
          <ScrollView
            horizontal={false}
            style={style.errorWrapper}
            contentContainerStyle={style.errorContentContainerStyle}
          >
            <View style={style.errorInnerContentContainerStyle}>
              <TextLato style={style.errorDescriptionCenter}>{i18n.t(descriptionKey)}</TextLato>
              {errorItems && errorItems.length > 0 && (
                <View>
                  {errorItems.map((item, index) => (
                    <View key={`${item}-${index}`} style={style.errorInnerWrapper}>
                      <TextLato style={style.errorDescriptionCenter}>{index + 1 + '. ' + item}</TextLato>
                    </View>
                  ))}
                </View>
              )}
            </View>
          </ScrollView>
        }
        confirmText={i18n.t(ctaKey)}
        handleConfirm={onConfirm}
        onClose={closeModal}
        onCloseOutside={closeModal}
        isVisible={dynamicModalVisible}
        type={type}
        id={id}
      />
    );
  },
);
